import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';
import { ISetSelfServiceScheduleParams } from '~src/spacesPlatform/utils/actionParams';

export class UpdateLinkedTasksScheduleSelfServiceSchedulesRequest extends Request<ISetSelfServiceScheduleParams, IEmptyResult> {
  constructor(params: ISetSelfServiceScheduleParams) {
    super('updateLinkedTasksSchedule', params);
  }
}
